<div class="search" *ngIf="user.type !== userType.PARENT">
    <form [formGroup]="research">
        <app-basic-input
            [classes]="'icon icon__search'"
            [inputConfig]="{ inputId: 'search', placeholder: 'MESSAGING.SEARCH', type: basicInputTypeEnum.TEXT }"
            formControlName="search"
        ></app-basic-input>
    </form>
</div>
<div class="list">
    <!--SELECTED STUDENT ON TOP-->
    <ng-container *ngIf="currentUser?.id !== user?.id">
        <div class="line selected">
            <div class="item">
                <p>
                    {{ currentUser.firstname + ' ' + currentUser.lastname }}
                    <span (click)="selectCurrentUser(user)" class="close icon i-close"></span>
                </p>
            </div>
            <ng-container *ngIf="user.type === userType.PARENT">
                <a class="icon i-eye selected" (click)="goToRoute('/directory/edit/student', { id: currentUser.id })"></a>
                <span
                    class="calendar-link icon i-calendar selected"
                    *ngIf="currentUser.settings.parent_divorced && currentUser.settings.costs_repartition_id === 1"
                    (click)="openCalendarModal(currentUser)"
                ></span>
                <span
                    class="qr-link icon i-qr selected"
                    *ngIf="currentUser.qrCodePath"
                    (click)="toggleQrCode(currentUser.id, currentUser.qrCodePath)"
                ></span>
            </ng-container>
        </div>
        <div class="infos selected" *ngIf="currentUser?.qrCodePath && showQrCode && userId === currentUser.id">
            <div class="row info-line">
                <img class="qr-code" [src]="baseUrl + qrCodePath" alt="QR-Code" />
            </div>
        </div>
    </ng-container>

    <ng-container *ngFor="let student of students | filterUser: searchText">
        <ng-container *ngIf="currentUser?.id !== student?.id">
            <div class="line">
                <div class="item" (click)="selectCurrentUser(currentUser && currentUser?.id === student.id ? user : student)">
                    <p>
                        {{ student.firstname + ' ' + student.lastname }}
                    </p>
                </div>
                <ng-container *ngIf="user.type === userType.PARENT">
                    <a class="icon i-eye" (click)="goToRoute('/directory/edit/student', { id: student.id })"></a>
                    <span
                        class="calendar-link icon i-calendar"
                        *ngIf="student.settings.parent_divorced && student.settings.costs_repartition_id === 1"
                        (click)="openCalendarModal(student)"
                    ></span>
                    <span
                        class="qr-link icon i-qr"
                        *ngIf="student.qrCodePath"
                        (click)="toggleQrCode(student.id, student.qrCodePath)"
                    ></span>
                </ng-container>
            </div>
            <div class="infos" *ngIf="student?.qrCodePath && showQrCode && userId === student.id">
                <div class="row info-line">
                    <img class="qr-code" [src]="baseUrl + qrCodePath" alt="QR-Code" />
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
